import React from 'react'
import { Dropdown, Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import ViewEvent from '../PageElements/EventElements/ViewEvent';
import FilterAgeGroupsDropdown from '../PageElements/EventElements/FilterAgeGroupsDropdown';

const Event = (props) => {
    const {
        isAdjudicator, handleClearEventInfo, ageGroups, filterAgeGroup, handleSetFilterAgeGroups,
        filterGenderGroup, handleSetFilterGenderGroups, competitorObject, setCompetitorObject, getCompetitors,
        adjudicators, setAdjudicators, isLoading, setIsLoading, setFilterGenderGroup, setFilterAgeGroup,
        setAgeGroups
    } = props;
    return (
        <div style={{ paddingTop: '20px', paddingBottom: '60px', width: '100%' }}>
            <div style={{ width: '90vw', marginLeft: 'auto', marginRight: 'auto' }}>
                    {!isAdjudicator &&
                        <div style={{ marginBottom: '30px' }}>
                            {/* Desktop Layout */}
                            <div className="desktop-only" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px', width: '100%' }}>
                                    <button className="green-glow-button" onClick={() => handleClearEventInfo('')}
                                        type="submit" style={{ marginBottom: 0 }}>
                                        <FontAwesomeIcon style={{ cursor: 'pointer' }} icon={faArrowLeft} /> Back to Events
                                    </button>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '10px' }}>
                                        <span style={{ color: '#26ffe1', whiteSpace: 'nowrap' }}>Select Competitor Group:</span>
                                        <Dropdown>
                                            <Dropdown.Toggle variant="light" id="custom-dropdown">
                                                {filterGenderGroup}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item onClick={() => {
                                                    handleSetFilterGenderGroups('Female')
                                                }}>Female</Dropdown.Item>
                                                <Dropdown.Item onClick={() => {
                                                    handleSetFilterGenderGroups('Male')
                                                }}>Male</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                        <FilterAgeGroupsDropdown
                                            ageGroups={ageGroups}
                                            filterAgeGroup={filterAgeGroup}
                                            handleSetFilterAgeGroups={handleSetFilterAgeGroups}
                                        />
                                    </div>
                            </div>

                            {/* Mobile Layout */}
                            <div className="mobile-only">
                                {/* Back to Events Button - Full Width */}
                                <Row>
                                    <Col xs={12}>
                                        <button className="green-glow-button" onClick={() => handleClearEventInfo('')}
                                            type="submit" style={{ marginBottom: '20px', width: '100%' }}>
                                            <FontAwesomeIcon style={{ cursor: 'pointer' }} icon={faArrowLeft} /> Back to Events
                                        </button>
                                    </Col>
                                </Row>

                                {/* Select Competitor Group Gender Dropdown - Full Width */}
                                <Row>
                                    <Col xs={12}>
                                        <div style={{ marginBottom: '15px' }}>
                                            <span style={{ color: '#26ffe1', display: 'block', marginBottom: '5px' }}>Select Competitor Group:</span>
                                            <Dropdown style={{ width: '100%' }}>
                                                <Dropdown.Toggle variant="light" id="custom-dropdown" style={{ width: '100%' }}>
                                                    {filterGenderGroup}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu style={{ width: '100%' }}>
                                                    <Dropdown.Item onClick={() => {
                                                        handleSetFilterGenderGroups('Female')
                                                    }}>Female</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => {
                                                        handleSetFilterGenderGroups('Male')
                                                    }}>Male</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </Col>
                                </Row>

                                {/* Age Selector - Full Width */}
                                <Row>
                                    <Col xs={12}>
                                        <div style={{ marginBottom: '15px' }}>
                                            <span style={{ color: '#26ffe1', display: 'block', marginBottom: '5px' }}>Age Group:</span>
                                            <div style={{ width: '100%' }}>
                                                <FilterAgeGroupsDropdown
                                                    ageGroups={ageGroups}
                                                    filterAgeGroup={filterAgeGroup}
                                                    handleSetFilterAgeGroups={handleSetFilterAgeGroups}
                                                    style={{ width: '100%' }}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    }
            <ViewEvent
                filterGenderGroup={filterGenderGroup}
                setFilterGenderGroup={setFilterGenderGroup}
                filterAgeGroup={filterAgeGroup}
                setFilterAgeGroup={setFilterAgeGroup}
                handleSetFilterAgeGroups={handleSetFilterAgeGroups}
                handleSetFilterGenderGroups={handleSetFilterGenderGroups}
                competitorObject={competitorObject}
                setCompetitorObject={setCompetitorObject}
                ageGroups={ageGroups}
                setAgeGroups={setAgeGroups}
                getCompetitors={getCompetitors}
                adjudicators={adjudicators}
                setAdjudicators={setAdjudicators}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                handleClearEventInfo={handleClearEventInfo}
            />
            </div>
        </div>
    )
}

export default Event